// extracted by mini-css-extract-plugin
export var about = "about-module--about--Um+LS";
export var paragraph = "about-module--paragraph--nl8sC";
export var resume = "about-module--resume--FRC-e";
export var details = "about-module--details--8l4aO";
export var profile = "about-module--profile--D-OzZ";
export var dots = "about-module--dots--szbII";